import { render, staticRenderFns } from "./NewClientModal.vue?vue&type=template&id=55a800a4"
import script from "./NewClientModal.vue?vue&type=script&lang=js"
export * from "./NewClientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports